import PayInvoiceMain from "./PayInvoiceMain.vue"
import BrandCardLayout from "@/layouts/BrandCardLayout.vue"
import {
	Route
} from "@/types"

export const route: Route[] = [
	{
		path: "/pay-invoice",
		name: "PayInvoice",
		component: PayInvoiceMain,
		meta: {
			layout: BrandCardLayout,
			module: "payInvoice",
			public: true
		}
	}
]
